export default __webpack_public_path__ + "static/media/SWTransparent.caf00190.png";